import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=4ef7ca57&scoped=true&"
import script from "./NotificationCenter.vue?vue&type=script&lang=js&"
export * from "./NotificationCenter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&id=4ef7ca57&lang=scss&scoped=true&"
import style1 from "./NotificationCenter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef7ca57",
  null
  
)

export default component.exports